import { render, staticRenderFns } from "./BindEmail.vue?vue&type=template&id=2dd5f668&scoped=true"
import script from "./BindEmail.vue?vue&type=script&lang=js"
export * from "./BindEmail.vue?vue&type=script&lang=js"
import style0 from "./BindEmail.vue?vue&type=style&index=0&id=2dd5f668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5f668",
  null
  
)

export default component.exports